export default __webpack_public_path__ + "static/media/OSMOS_CALCE-MATT_60X120_11.1e4dd3c3.jpg";